import React from "react";
import { motion } from "framer-motion";

const features = [
  { title: "Enterprise Software", desc: "Scalable, secure, and robust solutions." },
  { title: "Web Development", desc: "Modern, fast, and responsive applications." },
  { title: "AI & Automation", desc: "Intelligent, data-driven systems." },
];

const Features = () => {
  return (
    <section className="h-screen flex flex-col justify-center items-center text-center snap-start">
      <h2 className="text-3xl font-semibold text-secondary-500">Why Choose Us?</h2>
      <div className="grid md:grid-cols-3 gap-10 mt-10 max-w-5xl mx-auto">
        {features.map((feature, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
            className="p-6 bg-dark-500 rounded-lg shadow-lg text-center"
          >
            <h3 className="text-xl font-semibold">{feature.title}</h3>
            <p className="mt-2 text-light-200">{feature.desc}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Features;